"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[864],{

/***/ 4110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ IconCheckCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);


const IconCheckCircle = ({ size =49 , isSameHeight =false , height , color ="#46CA6B"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: isSameHeight ? size : height ? height : "48",
        viewBox: "0 0 49 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_dd_2137_7411)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "6.5",
                        y: "2",
                        width: "36",
                        height: "36",
                        rx: "18",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M31.7559 15.2443C32.0814 15.5699 32.0814 16.098 31.7559 16.4237L22.5974 25.5891C22.2722 25.9145 21.745 25.9148 21.4195 25.5896L17.2447 21.4198C16.9189 21.0945 16.9184 20.5664 17.2435 20.2404C17.5686 19.9144 18.0963 19.9139 18.422 20.2393L22.0076 23.8205L30.5774 15.2443C30.9028 14.9186 31.4305 14.9186 31.7559 15.2443Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_dd_2137_7411",
                    x: "0.5",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_2137_7411"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_2137_7411",
                            result: "effect2_dropShadow_2137_7411"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_2137_7411",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 2317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./src/lib/const.ts
var lib_const = __webpack_require__(5173);
;// CONCATENATED MODULE: ./src/lib/cloudflareImageResize.ts
// import Const from "../helpers/const"

const isImageResizable = (sourceImage)=>{
    const imageUrl = new URL(sourceImage);
    const imageHosts = lib_const/* CONST.IMAGE_HOSTS.split */.o.IMAGE_HOSTS.split(",");
    return imageHosts.includes(imageUrl.host);
};
const resizeImageUrl = (sourceImage, options)=>{
    try {
        const imageUrl = new URL(sourceImage);
        if (isImageResizable(sourceImage)) {
            const pathname = imageUrl.pathname + imageUrl.search;
            const { width , height , quality  } = options;
            let optionsText = width ? `width=${width}` : "";
            if (height) {
                optionsText += `,height=${height}`;
            }
            if (quality) {
                optionsText += `,quality=${quality}`;
            } else {
                optionsText += `,quality=75`;
            }
            if (width && height) {
                optionsText += `,fit=cover`;
            }
            if (width || height) {
                optionsText += `,format=auto`;
            }
            return `${imageUrl.origin}/cdn-cgi/image/${optionsText}${pathname}`;
        } else {
            return sourceImage;
        }
    } catch  {
        return sourceImage;
    }
};

;// CONCATENATED MODULE: ./src/components/Image/Image.tsx


const Image = (props)=>{
    const srcSet = props.src && isImageResizable(props.src) ? [
        1,
        2,
        3
    ].map((i)=>`${resizeImageUrl(props.src, {
            width: props.width * i,
            height: props.height * i
        })} ${i}x`).join(", ") : null;
    if (!props.src) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...props
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        loading: "lazy",
        ...props,
        srcSet: srcSet,
        src: props.src && (props.width || props.height) ? resizeImageUrl(props.src, {
            width: props.width,
            height: props.height
        }) : props.src
    }));
};


/***/ }),

/***/ 5789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zz": function() { return /* binding */ pushDataLayer; }
/* harmony export */ });
/* unused harmony exports pushEvent, pageview */
/* harmony import */ var lib_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5173);
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1927);


const gaId = lib_const__WEBPACK_IMPORTED_MODULE_0__/* .CONST.GA_ID */ .o.GA_ID;
const gtmId = lib_const__WEBPACK_IMPORTED_MODULE_0__/* .CONST.GTM_ID */ .o.GTM_ID;
// https://morganfeeney.com/how-to/integrate-google-tag-manager-with-next-js
const pushEvent = (stateLogin, currUser, rest)=>{
    let dataPush = {
        user_id: rest.user_id ?? null,
        referral_code: rest?.referral_code ?? null,
        event: rest?.event ?? "user_identity",
        ...rest
    };
    if (stateLogin == "LOGIN") {
        dataPush.user_id = currUser?.id;
        dataPush.referral_code = currUser?.referral !== "" ? currUser?.referral : null;
    } else {
        dataPush.referral_code = null;
        dataPush.user_id = null;
        dataPush.event = "user_identity";
    }
    if (true) {
        ;
        // @ts-ignore
        window.dataLayer.push({
            ...dataPush,
            ...rest
        });
    }
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
const pageview = (url)=>{
    //@ts-ignore
    window.gtag("config", gaId, {
        page_path: url
    });
};
const pushDataLayer = ({ ...rest })=>{
    if ((0,_ssr__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .j)()) {
        //@ts-ignore
        return window.dataLayer.push({
            ...rest
        });
    }
};


/***/ }),

/***/ 5803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePopupStoreFormSales; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9010);

const usePopupStoreFormSales = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        isShow: false,
        currentCtaEvent: "",
        isShowYoutubeModal: false,
        // actions
        showPopupFormSales (event) {
            set({
                isShow: true,
                currentCtaEvent: event
            });
        },
        closePopupFormSales () {
            set({
                isShow: false
            });
        },
        showPopupYoutube () {
            set({
                isShowYoutubeModal: true
            });
        },
        closePopupYoutube () {
            set({
                isShowYoutubeModal: false
            });
        }
    }));


/***/ }),

/***/ 8593:
/***/ (function(module) {

module.exports = JSON.parse('{"fJ":{"title":"Tingkatkan Kompetensi Profesional dengan <strong class=\'text-violet_main whitespace-nowrap\'>AI Interaktif </strong>","description":"Bertanya, berdiskusi, dan mendapatkan feedback dengan <span class=\'font-[700]\'>AI real-time 24/7</span> untuk pengembangan kompetensi Anda, didukung <span class=\'font-[700]\'>1.000+ kursus</span> berkualitas dari perusahaan dan universitas ternama."},"yX":{"title":"Client Sudah Bergabung dengan Learnext"},"Yt":{"title":"Kenapa Perusahaan Memilih Learnext?","description":"Solusi Pembelajaran Profesional yang Cerdas, Skalabel, dan Siap Hadapi Masa Depan","content":[{"title":"Peningkatan Kompetensi Cerdas Berbasis AI","description":"Coach AI interaktif, penilaian dan feedback instan, dengan alur pembelajaran yang adaptif sesuai kebutuhan tiap profesional.","icon":"book","buttonDesc":"Coba AI","imageUrl":["/images/benefit-section-1-2.png","/images/benefit-section-1-1.png"],"imageAlt":"lms-content"},{"title":"Konversi Materi Perusahaan Menjadi Video Kursus Interaktif","description":"Konversi otomatis dari file PPT atau PDF ke video kursus dengan suara pengajar, kuis, dan tugas interaktif.","icon":"electric","buttonDesc":"Konversi Video","imageUrl":["/images/benefit-section-2-4.png","/images/benefit-section-3-2.png"],"imageAlt":"activity-team"},{"title":"Fleksibel, Terintegrasi, dan Tanpa Batas Pengguna","description":"Akses mudah 24 jam, terintegrasi dengan LMS atau sistem HR apa pun, dan bebas jumlah peserta tanpa biaya tambahan.","icon":"currency","buttonDesc":"Lihat Paket Biaya","imageUrl":["/images/benefit-section-2-2.png","/images/benefit-section-2-1.png"],"imageAlt":"pricing-package"}]},"Iv":{"title":"Selain Interaktif AI, Tersedia Kursus untuk Support Pembelajaranmu","description":"Percepat pengembangan keterampilanmu dengan kombinasi AI interaktif dan kursus dari Perusahaan dan Universitas top dunia."},"un":{"title":"Mulai Tingkatkan Bisnis dengan <strong class=\'text-violet_main\'>Learnext</strong>","description":"Cari tahu lebih lanjut mengenai Learnext business bersama tim sales kami. Integrasikan Learnext dengan cepat dan akses beragam kursus langsung di LMS Anda. "},"yt":{"title":"Kata mereka terkait Learnext","testimonies":[{"name":"Nehemya Lay","job":"GM HR Intera Group (Aquaproof)","title":"Meningkatkan skill lebih dari 1.000 karyawan Intera Group","body":"Sebagai perusahaan dengan lebih dari 1.000 karyawan, pengembangan SDM kami telah mendapatkan manfaat yang begitu baik dari Learnext. Kami lihat dari tingkat engagement yang sangat tinggi, dengan lebih dari 30% dari karyawan kami menyelesaikan berbagai kursus dalam topik seperti creative thinking, growth mindset, dan social intelligence. Learnext telah membantu kami mengadopsi pendekatan pembelajaran yang lebih dinamis di seluruh organisasi kami. Ini sangat membantu meningkatkan dan mengembangkan keterampilan dan produktivitas tim kami secara terukur dan berkesinambungan.","urlPeople":"https://staging-static.gokampus.com/course-institutions/jnwQGz3qleyUmovUXwd6QHQxW6C8CaDwoL0JvHa6.jpg","urlInstitution":"https://s.gokampus.com/business/logo-aquaproof.png"},{"name":"Faisal, S.ST.Par., MM.Par, CHE","job":"Kepala Pusat Pengembangan SDM, Kementerian Pariwisata dan Ekonomi Kreatif","title":"Merevolusi pengembangan skill ASN di Kemenparekraf","body":"Learnext telah merevolusi pendekatan kami terhadap pengembangan SDM. Dengan menawarkan beragam kursus yang memberdayakan ASN untuk mengadopsi pembelajaran mandiri. Perubahan ini tidak hanya untuk meningkatkan keterampilan ASN, tetapi juga dapat mewujudkan peserta pendidikan dan pelatihan yang lebih baik, sesuai dengan misi kami.","urlPeople":"https://staging-static.gokampus.com/course-institutions/nlYVDWBi8zlx71gPnYwl1TXtwbhAg6ODB2g0QN9N.jpg","urlInstitution":"https://s.gokampus.com/business/logo-wonderful-indonesia.png"},{"name":"Denanda Dewanto","job":"Human Capital Development Division Head of Boga Group","title":"Membantu tim di Boga Group tetap unggul","body":"Learnext telah mentransformasi tim kami, dengan kursus-kursus penting yang populer di antara karyawan kami seperti creative thinking, data analytics, dan personal growth. Hal ini mengembangkan keterampilan dan pengetahuan tim kami, yang akhirnya meningkatkan kemampuan tim dan tetap unggul dalam industri yang sangat kompetitif saat ini.","urlPeople":"https://staging-static.gokampus.com/course-institutions/ANiwfJsqcagv17YZ5U0LRCu1ublXnLfRiM0qv2EL.jpg","urlInstitution":"https://s.gokampus.com/business/logo-boga-red.png"}]},"NI":{"title":"Pilih Paket sesuai Kebutuhan Perusahaanmu","description":"Tentukan paket yang sesuai untuk perusahaanmu, mulai dari langganan tahunan atau bulanan.","packets":[{"label":"FITUR"},{"label":"ENTERPRISE","price":63000000,"price_after_discount":50000000,"price_certificate":63000000,"price_certificate_discount":50000000,"description":null,"benefits":["<strong>Unlimited learners - tanpa biaya per pengguna </strong>dalam satu entitas organisasi.","<strong>200 kursus</strong> (dapat diganti hingga 20 kursus per bulan), dengan serta sertifikat resmi dari mitra konten.","Konversi materi PPT internal menggunakan AI menjadi kursus digital (video, kuis, dan tugas) hingga <strong>total 1.000 menit</strong> durasi video.","<strong>Nexa, AI coach interaktif</strong> untuk semua pengguna hingga total durasi <strong>24.000 menit per tahun</strong> waktu diskusi. <br/> Upload file knowledge base perusahaan/organisasi untuk AI interaktif hingga <strong>10GB</strong> berbasis teks (dokumen tulisan, video bersuara, etc.), berbasis gambar (grafik, ilustrasi, etc.), maupun halaman website (url).","Dashboard data manager (visualisasi data standar)."],"selected":true,"tagline":"Paling Banyak Dipilih Perusahaan","button":"Coba Gratis","id":"price-enterprise"},{"label":"ULTIMATE","price":105000000,"price_after_discount":85000000,"price_certificate":105000000,"price_certificate_discount":85000000,"benefits":["<strong>Unlimited learners - tanpa biaya per pengguna </strong>dalam satu entitas organisasi.","<strong>Semua (1,000+) kursus</strong> (otomatis ditambah setiap minggu), dengan sertifikat resmi dari mitra konten dengan penyesuaian desain.","Konversi materi PPT internal menggunakan AI menjadi kursus digital (video, kuis, dan tugas) hingga <strong>total 5.000 menit</strong> durasi video.","<strong>Nexa, AI coach interaktif</strong> untuk semua pengguna hingga total durasi <strong>48.000 menit per tahun</strong> waktu diskusi. <br/> Upload file knowledge base perusahaan/organisasi untuk AI interaktif hingga <strong>20GB</strong> berbasis teks (dokumen tulisan, video bersuara, etc.), berbasis gambar (grafik, ilustrasi, etc.), maupun halaman website (url).","Dashboard data manager yang dapat disesuaikan kebutuhan visualisasi data."],"selected":false,"tagline":null,"button":"Coba Gratis","id":"price-enterprise-plus"}],"notes":["Semua harga tercantum belum termasuk PPN"],"premiumChapterWithFee":"Opsional & biaya tambahan","premiumChapterUnlimited":"Tanpa batas & tanpa biaya tambahan","newPacketsId":["","price-pro","price-enterprise","price-enterprise-plus"],"newPackets":[["Program Kursus Pilihan","50","1.000+","1.000+"],["Penggantian Program Kursus","1x sebulan","Update otomatis","Update otomatis"],["Jumlah Pelajar","Tidak terbatas","Tidak terbatas","Tidak terbatas"],["No charge per user","✅","✅","✅"],["Realtime Dashboard","✅","✅","✅"],["Premium Chapter dan Sertifikat","Opsional, biaya tambahan","Opsional, biaya tambahan","Tanpa batas & tanpa biaya tambahan"],["Customizable branding","-","-","✅"]]},"fG":{"title":"Solusi Terbaik Tingkatkan Bisnis Anda dengan <strong class=\'text-violet_main_to_dark_purple_surface\'>Learnext</strong> ","description":"Dapatkan seluruh manfaat Learnext","benefits":["Peningkatan Kompetensi Cerdas Berbasis AI","Konversi Materi Menjadi Video Kursus Interaktif","Fleksibel, Terintegrasi, dan Tanpa Batas Pengguna"],"institutionTitle":"Belajar dari perusahaan, universitas, dan trainer terkemuka.","contactSales":"Jadwalkan Demo","contactSalesDesc":"Tim Learnext siap membantu dan akan segera menghubungi Anda","fieldContactInput":"Masukkan no. handphone/email Anda","fieldContactPlaceholder":"08123456789 / example@mail.com","fieldContactHrisPlaceholder":"08123456789","fieldContactHrisInput":"Masukkan no. handphone Anda","fieldNameInput":"Masukan nama Anda","fieldCompanyInput":"Masukan nama perusahaan Anda","fieldNamePlaceholder":"John Doe","fieldCompanyPlaceholder":"PT ABC","fieldSubmit":"Kirim"},"zx":{"viewDemo":"Lihat Demo","contactSales":"Jadwalkan Demo","courseTotal":"Total Kursus","partnerTotal":"Total Partner","learnerTotal":"Total Pelajar","scheduleDemo":"Jadwalkan Demo"},"Y1":{"TI":{"title":"Jelajahi & Pilih Kursus Untuk Perusahaanmu!","description":"Dengan Learnext, kamu dapat menjelajahi ribuan kursus dari institusi terpercaya langsung di LMS/HRIS perusahaanmu. Temukan dan pilih kursus-kursus terbaik yang sesuai dengan minat dan kebutuhan perusahaanmu.","stepper":["Pilih Kursus","Kirim daftar pilihan kursus","Dapatkan akses kursus langsung di LMS/HRIS perusahaanmu"]},"kA":{"form":{"title":"Lengkapi Informasi Perusahaan","description":"Sebelum mengirim kursus pilihanmu, pastikan untuk melengkapi informasi perusahaan dengan benar ya","dataForm":[{"label":"Nama Lengkap","placeholder":"Masukkan nama lengkap Anda","name":"name","value":"","required":true},{"label":"Email","placeholder":"nama@email.com","name":"email","value":"","required":true},{"label":"No Handphone","placeholder":"081234567890","name":"phone","value":"","required":true},{"label":"Versi Moodle","placeholder":"Pilih Versi Moodle","name":"platform_version","value":"","required":false}],"button":{"send":"Kirim Sekarang"}},"modal":{"success":{"title":"Hore! Kursus Pilihanmu Telah Terkirim","description":"Daftar kursus pilihanmu berhasil terkirim. Tim Learnext akan segera menghubungi kamu untuk membahas langkah selanjutnya.","button":"Kembali ke Homepage"}}}}}');

/***/ })

}]);